module.exports = __webpack_public_path__ + "img/dp-endpoint.0153153d.svg";